import type { Template } from "@/types";

export const LA_07_H5_V2: Template[] = [
    {
        id: "la-07-h5v2-01",
        name: "LA 01 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 96, y: 52, width: 205, height: 137, rotation: 0, imageRotation: 0 },
            { id: "2", x: 96, y: 197, width: 205, height: 137, rotation: 0, imageRotation: 0 },
            { id: "3", x: 96, y: 343, width: 205, height: 137, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 52, width: 272, height: 429, rotation: 0, imageRotation: 0 },
            { id: "5", x: 761, y: 86, width: 249, height: 176, rotation: 0, imageRotation: 0 },
            { id: "6", x: 761, y: 270, width: 249, height: 176, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 86, width: 250, height: 359, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-02",
        name: "LA 02 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 94, y: 44, width: 276, height: 443, rotation: 0, imageRotation: 0 },
            { id: "2", x: 378, y: 44, width: 205, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 378, y: 193, width: 205, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 756, y: 45, width: 516, height: 307, rotation: 0, imageRotation: 0 },
            { id: "5", x: 756, y: 360, width: 167, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 931, y: 360, width: 167, height: 126, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1106, y: 360, width: 166, height: 126, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-03",
        name: "LA 03 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 127, y: 52, width: 416, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 278, width: 269, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 278, width: 139, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 771, y: 52, width: 272, height: 429, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1051, y: 52, width: 205, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1051, y: 198, width: 205, height: 137, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1051, y: 344, width: 205, height: 137, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-04",
        name: "LA 04 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 163, y: 62, width: 190, height: 132, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 201, width: 190, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 341, width: 190, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 62, width: 263, height: 409, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 62, width: 264, height: 409, rotation: 0, imageRotation: 0 },
            { id: "6", x: 904, y: 62, width: 286, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 904, y: 271, width: 286, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-05",
        name: "LA 05 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 163, y: 62, width: 190, height: 132, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 201, width: 190, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 163, y: 341, width: 190, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 361, y: 62, width: 263, height: 409, rotation: 0, imageRotation: 0 },
            { id: "5", x: 632, y: 62, width: 286, height: 201, rotation: 0, imageRotation: 0 },
            { id: "6", x: 632, y: 271, width: 286, height: 200, rotation: 0, imageRotation: 0 },
            { id: "7", x: 926, y: 62, width: 264, height: 409, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-06",
        name: "LA 06 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 28, y: 62, width: 575, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 62, width: 131, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 271, width: 284, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 62, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 903, y: 271, width: 284, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1042, y: 62, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1195, y: 271, width: 131, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-07",
        name: "LA 07 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 28, y: 62, width: 575, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 62, width: 131, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 271, width: 131, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 750, y: 62, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 750, y: 271, width: 284, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1042, y: 62, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1042, y: 271, width: 284, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-08",
        name: "LA 08 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 28, y: 62, width: 575, height: 409, rotation: 0, imageRotation: 0 },
            { id: "2", x: 611, y: 62, width: 284, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 611, y: 271, width: 284, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 903, y: 62, width: 283, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 903, y: 271, width: 283, height: 200, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1194, y: 62, width: 132, height: 201, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1194, y: 271, width: 132, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-09",
        name: "LA 09 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 61, y: 69, width: 333, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 61, y: 300, width: 219, height: 164, rotation: 0, imageRotation: 0 },
            { id: "3", x: 288, y: 300, width: 220, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 402, y: 69, width: 334, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 516, y: 300, width: 220, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 744, y: 69, width: 269, height: 396, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 69, width: 270, height: 396, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h5v2-10",
        name: "LA 10 - H5V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h5_v2_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 61, y: 67, width: 270, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 339, y: 67, width: 269, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 616, y: 239, width: 334, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 958, y: 239, width: 333, height: 224, rotation: 0, imageRotation: 0 },
            { id: "5", x: 616, y: 67, width: 220, height: 164, rotation: 0, imageRotation: 0 },
            { id: "6", x: 844, y: 67, width: 220, height: 164, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1072, y: 67, width: 219, height: 164, rotation: 0, imageRotation: 0 }
        ],
    }
];